import { MapPin, UserCheck, HeartHandshake, ShieldCheck, Flag, Siren, Calendar, Users, CalendarCheck, ImagePlus, Wallet, ClipboardList, MessageSquare, Link2, Star, HelpCircle } from "lucide-react";

/** Bounded set of icon keys admins can pick for Safety Points and Photographer Benefits —
 * keeping this fixed (rather than any arbitrary string) avoids broken/missing icons on the site. */
export const ICON_MAP = {
  MapPin,
  UserCheck,
  HeartHandshake,
  ShieldCheck,
  Flag,
  Siren,
  Calendar,
  Users,
  CalendarCheck,
  ImagePlus,
  Wallet,
  ClipboardList,
  MessageSquare,
  Link2,
  Star,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);

export const IconFromKey = ({ iconKey, className }) => {
  const Icon = ICON_MAP[iconKey] || HelpCircle;
  return <Icon className={className} />;
};
